var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C14.025 0 14.5172 0.276563 14.7844 0.726563L19.2844 8.22656C19.561 8.69063 19.5657 9.26719 19.3032 9.73594C19.0407 10.2047 18.5391 10.4953 18 10.4953H9.00004C8.46098 10.4953 7.9641 10.2047 7.69691 9.73594C7.42973 9.26719 7.4391 8.69063 7.71566 8.22656L12.2157 0.726563C12.4829 0.276563 12.975 0 13.5 0Z",
    fill: "#F28520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.375V14.625C13.5 13.5891 14.3391 12.75 15.375 12.75H22.125C23.1609 12.75 24 13.5891 24 14.625V21.375C24 22.4109 23.1609 23.25 22.125 23.25H15.375C14.3391 23.25 13.5 22.4109 13.5 21.375Z",
    fill: "#3360AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24C9.31406 24 12 21.3141 12 18C12 14.6859 9.31406 12 6 12C2.68594 12 0 14.6859 0 18C0 21.3141 2.68594 24 6 24Z",
    fill: "#208C72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.8e38f5d4c4b91a7b4c0378cc8cfdc89f.svg";
export { ForwardRef as ReactComponent };